var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('div',{staticClass:"z-50 flex justify-center",class:[
    _vm.absolute ? 'absolute inset-0' : 'relative',
    _vm.spinnerOffsetTop ? 'items-start' : 'items-center',
    { 'min-h-[calc(100vh-72px)] sm:min-h-[calc(100vh-80px)]': _vm.fullHeight },
    { 'bg-white bg-opacity-50': _vm.background },
  ],style:(_setup.preloaderStyles)},[_c('UiSpinner',{attrs:{"value":_vm.value}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }